import React from "react";
import HeroSection from "./AIMLForDroneApplication/HeroSection";
import MagicBento from "./AIMLForDroneApplication/MagicBento";
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const AimlForDroneApplicationMain = () => {
  return (
    <div>
      <HeroSection />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </div>
  );
};

export default AimlForDroneApplicationMain;
